module.exports = "## Checkbox\n\nA [checkbox](https://www.google.com/design/spec/components/selection-controls.html#selection-controls-checkbox)\nis used to verify which options you want selected from a group.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Checkbox/README.md
 ** module id = 949
 ** module chunks = 0
 **/